var React = require('react');

function MapEsIb (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M134.673 69.179L55.248 115.51l43.272 12.364a6 6 0 014.044 3.871l13.21 39.631 46.577-39.923-27.678-62.274zm-1.182-10.888a6 6 0 018.506 2.746l30.702 69.078a6 6 0 01-1.578 6.992l-53.356 45.733c-3.235 2.773-8.249 1.385-9.597-2.658l-14.424-43.273-50.26-14.36c-5.082-1.452-5.94-8.289-1.375-10.952l91.382-53.306zM47.992 163.188c5.222-1.864 9.962 3.745 7.253 8.583l-17.07 30.48a6 6 0 01-8.303 2.224l-25.604-15.24c-4.362-2.596-3.73-9.099 1.051-10.806l42.673-15.241zm-6.686 13.007l-24.621 8.793 14.773 8.794 9.848-17.587zM228.272 57.021l-25.759 7.728 38.639 19.32-12.88-27.048zm.413-10.564a6 6 0 017.141 3.168l19.353 40.641c2.454 5.153-2.995 10.499-8.1 7.946l-58.06-29.03c-4.859-2.43-4.245-9.552.96-11.113l38.706-11.612z","fill":"#000"}));
}

MapEsIb.defaultProps = {"fill":"none","viewBox":"0 0 256 256"};

module.exports = MapEsIb;

MapEsIb.default = MapEsIb;
